import { Component, OnInit } from '@angular/core';
import { FetchData } from 'app/shared/generalMethods';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-attendance-student',
  templateUrl: './attendance-student.component.html',
  styleUrls: ['./attendance-student.component.scss']
})
export class AttendanceStudentComponent implements OnInit {
  programs: any[] = [];
  classSchedules: any[] = [];
  filteredClassSchedules: any[] = [];
  attendanceRecords: any[] = [];
  canViewAttendance: boolean = false;
  isAdmin: boolean = false;

  constructor(
    private _fetchData: FetchData,
    private snackBar: MatSnackBar,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.checkPermissions();
    if (this.canViewAttendance) {
      this.loadInitialData();
    }
  }

  private checkPermissions(): void {
    const { countAdmin, countStaff, lstStaffData } = this._fetchData.data;

    // Admin has all permissions
    if (countAdmin === 1) {
      this.isAdmin = true;
      this.canViewAttendance = true;
      return;
    }

    // Check staff permissions
    if (countStaff === 1 && lstStaffData && lstStaffData.length > 0) {
      const permissionSets = lstStaffData[0].Permission_Sets__c;
      if (permissionSets) {
        try {
          const permissions = JSON.parse(permissionSets.replace(/&quot;/g, '"'));
          if (permissions.attendance) {
            this.canViewAttendance = permissions.attendance.view || false;
          }
        } catch (error) {
          console.error('Error parsing permissions:', error);
        }
      }
    }
  }

  loadInitialData(): void {
    const adminId = localStorage.getItem('adminId');
    const dataSet = this._fetchData.data;

    if (!dataSet) {
      this.showError('No data available');
      return;
    }

    this.attendanceRecords = dataSet.lstAttendance || [];
    const countAdmin = dataSet.countAdmin || 0;
    const countStaff = dataSet.countStaff || 0;
    const lstPrograms = dataSet.lstPrograms || [];
    const lstClassSchedules = dataSet.lstClassSchedules || [];
    const lstStaffData = dataSet.lstStaffData || [];

    // Admin case
    if (adminId) {
      this.programs = lstPrograms.filter(
        (p: any) => p.Administrator__c === adminId
      );

      const programIds = this.programs.map(p => p.Id);
      this.classSchedules = lstClassSchedules.filter(
        (cs: any) => programIds.includes(cs.Program__c)
      );
    }

    // Staff case
    if (countAdmin === 0 && countStaff === 1 && lstStaffData.length > 0) {
      const staff = lstStaffData[0];
      const staffAdminId = staff.Administrator__c;

      this.programs = lstPrograms.filter(
        (p: any) => p.Administrator__c === staffAdminId
      );

      const programIds = this.programs.map(p => p.Id);
      this.classSchedules = lstClassSchedules.filter(
        (cs: any) => programIds.includes(cs.Program__c)
      );
    }

    this.filteredClassSchedules = this.classSchedules;
  }



  // Updated to match detail component's approach
  getAttendanceStatus(classScheduleId: string): boolean {
    return this.attendanceRecords.some(
      (att: any) => att.Class_Schedule__c === classScheduleId
    );
  }

  // Rest of your existing methods remain the same...
  onProgramChange(programId: string): void {
    if (programId) {
      this.filteredClassSchedules = this.classSchedules.filter(
        (cs: any) => cs.Program__c === programId
      );
    } else {
      this.filteredClassSchedules = this.classSchedules;
    }
  }

  getProgramName(programId: string): string {
    const program = this.programs.find(p => p.Id === programId);
    return program ? program.Name : '--';
  }

  formatTime(timeString: string): string {
    if (!timeString) { return '--'; }

    try {
      const [hours, minutes] = timeString.split(':');
      // eslint-disable-next-line radix
      const hourNum = parseInt(hours);
      const period = hourNum >= 12 ? 'PM' : 'AM';
      const hour12 = hourNum % 12 || 12;

      return `${hour12}:${minutes} ${period}`;
    } catch (e) {
      return timeString;
    }
  }

onViewAttendance(classSchedule: any): void {
  const classDate = new Date(classSchedule.Date__c);
  const today = new Date();

  classDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  if (classDate > today) {
    this.snackBar.open(
      'You can only view attendance for today or previous dates.',
      'Close',
      { duration: 3000, verticalPosition: 'top' }
    );
    return;
  }

  const hasAttendance = this.attendanceRecords.some(
    (att: any) => att.Class_Schedule__c === classSchedule.Id
  );

  this.router.navigate(['/attendance-detail', classSchedule.Id], {
    state: { hasExistingAttendance: hasAttendance }
  });
}


  showError(message: string): void {
    this.snackBar.open(message, 'Close', { duration: 5000 });
  }
}
